module.exports = __webpack_public_path__ + "c66936867829b2d078444f369d33ae29.png";